var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.status,{tag:"component",attrs:{"show-icon":_vm.showIcon}},[_c('span',{attrs:{"slot":"link"},slot:"link"},[_vm._v("link")])])}
var staticRenderFns = []

export { render, staticRenderFns }